import { render } from "./RiProdoffering70.vue?vue&type=template&id=d7175bfa"
import script from "./RiProdoffering70.vue?vue&type=script&lang=js"
export * from "./RiProdoffering70.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdoffering70.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d7175bfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d7175bfa', __exports__)) {
    api.reload('d7175bfa', __exports__)
  }
  
  module.hot.accept("./RiProdoffering70.vue?vue&type=template&id=d7175bfa", () => {
    api.rerender('d7175bfa', render)
  })

}


export default __exports__